import logo from '../assets/images/logo.png'

type BrandLogoProps = {
    className?: string
}

function BrandLogo({ className }: BrandLogoProps) {
    return <img src={logo} alt="LanceQ" className={className} />
}

export default BrandLogo